import { address } from './address';
import { cart } from './cart';
import { common } from './common';
import { myAccount } from './my-account';
import { payment } from './payment';
import { product } from './product';
import { pwa } from './pwa';
import { user } from './user';

export const en = {
  address,
  cart,
  common,
  myAccount,
  payment,
  product,
  pwa,
  user,
};
